import { render, staticRenderFns } from "./PscDeficiencyCodeGroupTable.vue?vue&type=template&id=5c3ec0d0&scoped=true&"
import script from "./PscDeficiencyCodeGroupTable.vue?vue&type=script&lang=js&"
export * from "./PscDeficiencyCodeGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ec0d0",
  null
  
)

export default component.exports